export default __webpack_public_path__ + "1.18.20/static/media/libreLinkUp-small.06b9e023.svg";